var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorsorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 10L4.8 7.5H3V0H1.8V7.5H0L2.4 10ZM5.4 2.5H10.8V3.75H5.4V2.5ZM5.4 5H9.6V6.25H5.4V5ZM5.4 0H12V1.25H5.4V0ZM5.4 7.5H8.4V8.75H5.4V7.5Z",
    fill: "#272728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorsorting);
export default __webpack_public_path__ + "static/media/Vectorsorting.5d0517cd40d60986c1a776906908f2ed.svg";
export { ForwardRef as ReactComponent };